module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Light.woff2?b83c2d02dbebe312af931268f67fa0a4";